(() => {
  'use strict';
  const selector = 'iframe.smile-panel-frame';
  const styleId = 'cabane-smile-beige';
  const trackedFrames = new WeakSet();
  const pendingDocuments = new WeakSet();
  const headingFont = document.querySelector('link[rel="preload"][as="font"][href*="preview-anton-400.ttf"]')?.href;
  const css = `
    ${headingFont ? `@font-face { font-family: 'Cabane Anton'; src: url(${JSON.stringify(headingFont)}) format('truetype'); font-weight: 400; font-style: normal; font-display: swap; }` : ''}
    body.panel-body { color: #111111 !important; }
    .panel-body .panel-wrapper {
      --banner-base-colour: #f3e7d7 !important;
      --banner-gradient-dark-colour: #f3e7d7 !important;
      --link-colour: #b94318 !important;
    }
    .panel-body .main-panel-container,
    .panel-body .panel-expanded-header,
    .panel-body .panel-fixed-header,
    .panel-body .panel-footer {
      background-color: #f3e7d7 !important;
      background-image: none !important;
      color: #111111 !important;
    }
    .panel-body .panel-card-container,
    .panel-body .panel-subview {
      background-color: #f8efe3 !important;
      color: #111111 !important;
      box-shadow: 0 0 0 1px #ddcbb4 !important;
    }
    .panel-body .banner-content { color: #111111 !important; text-shadow: none !important; }
    .panel-body .points-balance,
    .panel-body .card-list-title,
    .panel-body .card-heading,
    .panel-body .list-title .heading {
      color: #b94318 !important;
    }
    .panel-body .text-muted { color: #62594f !important; }
    .panel-body .card-list-title.text-muted { color: #b94318 !important; }
    .panel-body .card-list-item { color: #111111 !important; }
    .panel-body .card-list-item:hover { background-color: #ebdcc8 !important; }
    .panel-body .card-list-item:active { background-color: #dfc9ad !important; }
    .panel-body .card-list-container.with-border-bottom { border-color: #ddcbb4 !important; }
    .panel-body .panel-footer { border-top: 1px solid #ddcbb4; box-shadow: none !important; }
    .panel-body .powered-by-text { color: #62594f !important; }
    .panel-body .compact-banner.panel-header-container .panel-expanded-header {
      height: 200px;
      padding: 64px 24px 20px;
    }
    .panel-body .compact-banner.panel-header-container.expanded-header + .panel-container {
      padding-top: 188px;
    }
    .panel-body .compact-banner.panel-header-container.collapsed .panel-expanded-header {
      transform: translate3d(0, -140px, 0) !important;
    }
    .panel-body .banner-content .header-icon:empty { display: none; }
    .panel-body .banner-content .header-secondary {
      font: 600 10px/1.2 Arial, sans-serif;
      letter-spacing: 1.6px;
      margin-bottom: 10px;
      color: #111111;
    }
    .panel-body .banner-content .header-primary {
      color: #111111 !important;
      font-family: 'Cabane Anton', Impact, 'Arial Narrow', sans-serif !important;
      font-size: 34px !important;
      font-weight: 400;
      line-height: 1.04;
      letter-spacing: 0.15px;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
    }
    .panel-body .cabane-smile-title-line { display: block; }
    .panel-body .banner-content .header-primary::after {
      content: '';
      display: block;
      width: 42px;
      height: 4px;
      margin-top: 12px;
      background: #ef6a32;
    }
  `;

  function styleTitle(doc) {
    const title = doc.querySelector('.banner-content .header-primary');
    if (!title || title.querySelector('.cabane-smile-title-line') ||
        title.textContent.trim() !== 'TON SHOP. TES AVANTAGES.') return;
    const first = doc.createElement('span');
    const second = doc.createElement('span');
    first.className = second.className = 'cabane-smile-title-line';
    first.textContent = 'TON SHOP. ';
    second.textContent = 'TES AVANTAGES.';
    title.replaceChildren(first, second);
  }

  function apply(frame) {
    let doc;
    try { doc = frame.contentDocument; } catch { return; }
    if (!doc || doc.getElementById(styleId)) return;
    if (doc.head) {
      const style = doc.createElement('style');
      style.id = styleId;
      style.textContent = css;
      doc.head.appendChild(style);
      styleTitle(doc);
      new MutationObserver(() => styleTitle(doc)).observe(doc, { childList: true, subtree: true });
      return;
    }
    if (pendingDocuments.has(doc)) return;
    pendingDocuments.add(doc);
    const ready = new MutationObserver(() => {
      if (doc.head) {
        ready.disconnect();
        apply(frame);
      }
    });
    ready.observe(doc, { childList: true, subtree: true });
  }

  function track(frame) {
    if (trackedFrames.has(frame)) return;
    trackedFrames.add(frame);
    frame.addEventListener('load', () => apply(frame));
    apply(frame);
  }

  function scan(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) track(node);
    node.querySelectorAll(selector).forEach(track);
  }

  document.querySelectorAll(selector).forEach(track);
  new MutationObserver((records) => {
    for (const record of records) record.addedNodes.forEach(scan);
  }).observe(document.body, { childList: true, subtree: true });
})();

(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 749px)');
  const frameSelector = '#smile-lite-launcher-frame, iframe.smile-launcher-frame';
  const tracked = new WeakSet();
  const launcherStyles = new Set();
  const styleId = 'cabane-mobile-widgets';
  const pageStyle = document.createElement('style');
  pageStyle.textContent = `
    @media (max-width: 749px) {
      :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container) {
        width: 100px !important;
        height: 44px !important;
        left: max(12px, env(safe-area-inset-left)) !important;
        bottom: calc(12px + env(safe-area-inset-bottom)) !important;
      }
      shopify-chat::part(activator) {
        width: 44px !important;
        min-width: 44px !important;
        height: 44px !important;
      }
      html.cabane-widget-text-overlap shopify-chat::part(activator),
      html.cabane-widget-text-overlap :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container) {
        visibility: hidden !important;
        pointer-events: none !important;
      }
      html.lcg-chat-sensitive :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      html.lcg-search-open :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      html:has(.lcg-shop-menu[open]) :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body.lcg-wishlist-locked :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body.lcg-consent-open :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body:has(cart-drawer.active) :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body:has(.mobile-facets__disclosure[open]) :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container) {
        visibility: hidden !important;
        pointer-events: none !important;
      }
    }
  `;
  document.head.appendChild(pageStyle);

  let visibilityFrame;
  const textSelector = 'main h1, main h2, main h3, main h4, main p, main button, main label, footer h2, footer p, footer input';
  function updateTextVisibility() {
    visibilityFrame = undefined;
    let overlap = false;
    if (mobile.matches) {
      const launcher = document.querySelector('#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container');
      const bottom = launcher?.getBoundingClientRect().bottom || window.innerHeight - 12;
      const right = document.documentElement.clientWidth - 12;
      overlap = Array.from(document.querySelectorAll(textSelector)).some(element => {
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > bottom - 44 && rect.top < bottom &&
          ((rect.left < 112 && rect.right > 12) || (rect.left < right && rect.right > right - 44));
      });
    }
    document.documentElement.classList.toggle('cabane-widget-text-overlap', overlap);
  }
  function scheduleTextVisibility() {
    if (visibilityFrame === undefined) visibilityFrame = requestAnimationFrame(updateTextVisibility);
  }
  window.addEventListener('scroll', scheduleTextVisibility, { passive: true });
  window.addEventListener('resize', scheduleTextVisibility, { passive: true });
  window.addEventListener('load', scheduleTextVisibility, { once: true });
  scheduleTextVisibility();

  function styleLauncher(frame) {
    let doc;
    try { doc = frame.contentDocument; } catch { return; }
    if (!doc?.head || doc.getElementById(styleId)) return;
    const style = doc.createElement('style');
    style.id = styleId;
    style.media = mobile.matches ? 'all' : 'not all';
    style.textContent = `
      button, button.smile-improved-mobile-launcher {
        box-sizing: border-box !important;
        width: 100px !important;
        min-width: 100px !important;
        height: 44px !important;
        max-height: 44px !important;
        padding: 0 10px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 6px !important;
        font-size: 12px !important;
        line-height: 1 !important;
      }
      button img, button.smile-improved-mobile-launcher img {
        width: 20px !important;
        height: 20px !important;
        flex: 0 0 20px !important;
      }
      button img + span { margin-left: 0 !important; }
      button.launcher-button { padding: 0 !important; }
      .launcher-container {
        box-sizing: border-box !important;
        width: 100px !important;
        height: 44px !important;
        min-height: 44px !important;
        padding: 0 10px !important;
        justify-content: center !important;
      }
      .launcher-content-container {
        align-items: center !important;
        justify-content: center !important;
        gap: 6px !important;
      }
      .launcher-text { margin: 0 !important; font-size: 12px !important; line-height: 20px !important; }
      .launcher-close-icon { width: 20px !important; height: 20px !important; margin: 12px 40px !important; }
      .close-icon { width: 20px; height: 20px; margin: 12px auto; }
    `;
    doc.head.appendChild(style);
    launcherStyles.add(style);
  }

  function styleChat(host, attempts = 0) {
    const root = host.shadowRoot;
    if (!root) {
      if (host.isConnected && attempts < 20) {
        window.setTimeout(() => styleChat(host, attempts + 1), 250);
      }
      return;
    }
    if (root.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media (max-width: 749px) {
        .activator-nudge--right {
          right: max(12px, env(safe-area-inset-right)) !important;
          bottom: calc(12px + env(safe-area-inset-bottom)) !important;
        }
        button.activator {
          width: 44px !important;
          min-width: 44px !important;
          height: 44px !important;
          padding: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 0 !important;
        }
        .activator__label { display: none !important; }
        .activator__icon {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 22px !important;
          height: 22px !important;
          margin: 0 !important;
          flex: 0 0 22px !important;
        }
        .activator__icon svg { display: block; width: 22px; height: 22px; }
        .activator__icon shopify-chat-icon { display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; }
      }
    `;
    root.appendChild(style);
    const trackRuntime = () => {
      root.querySelectorAll('shopify-agent-runtime').forEach(runtime => {
        if (tracked.has(runtime)) return;
        tracked.add(runtime);
        customElements.whenDefined('shopify-agent-runtime').then(() => styleChat(runtime));
      });
    };
    trackRuntime();
    new MutationObserver(trackRuntime).observe(root, { childList: true, subtree: true });
  }

  function track(node) {
    if (tracked.has(node)) return;
    tracked.add(node);
    if (node.matches(frameSelector)) {
      node.addEventListener('load', () => styleLauncher(node));
      styleLauncher(node);
    } else {
      customElements.whenDefined('shopify-chat').then(() => styleChat(node));
    }
  }

  const selector = `${frameSelector}, shopify-chat`;
  function scan(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) track(node);
    node.querySelectorAll(selector).forEach(track);
  }
  document.querySelectorAll(selector).forEach(track);
  new MutationObserver(records => {
    for (const record of records) record.addedNodes.forEach(scan);
  }).observe(document.body, { childList: true, subtree: true });
  mobile.addEventListener('change', () => {
    for (const style of launcherStyles) {
      if (!style.isConnected) launcherStyles.delete(style);
      else style.media = mobile.matches ? 'all' : 'not all';
    }
  });
})();
